import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const RosterPlanService = {
  getRosterPlans() {
    return httpClient.post(endPoints.getRosterPlans);
  },
  updateRosterPlan(obj) {
    return httpClient.post(endPoints.updateRosterPlan, obj);
  },
  addRosterPlan(obj) {
    return httpClient.post(endPoints.addRosterPlan, obj);
  },
  deleteRosterPlan(obj) {
    return httpClient.post(endPoints.deleteRosterPlan, obj);
  }
};

export default RosterPlanService;



// WEBPACK FOOTER //
// ./src/service/RosterPlanService.js